import { render, staticRenderFns } from "./_package.vue?vue&type=template&id=4b672110&scoped=true"
import script from "./_package.vue?vue&type=script&lang=js"
export * from "./_package.vue?vue&type=script&lang=js"
import style0 from "./_package.vue?vue&type=style&index=0&id=4b672110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b672110",
  null
  
)

export default component.exports